<template>
  <img
    v-if="brokerLogo"
    class="mx-auto my-8 hidden h-11 w-auto md:block"
    :src="brokerLogo"
    :alt="`${brokerName} logo`"
  />
  <layout class="mt-6">
    <h1 class="header-text text-center">Sorry,</h1>
    <p class="mb-4 text-dark-gray">
      <slot />
    </p>
    <button-main
      v-if="portalConfig[companyType]"
      @click="$router.push(portalConfig[companyType].route)"
    >
      {{ portalConfig[companyType].text }}
      <img
        class="link-icon inline"
        src="@/assets/link-icon.svg"
        alt=""
      />
    </button-main>
  </layout>
</template>

<script>
import { onMounted, ref, computed } from 'vue';
import ButtonMain from '@/components/Button.vue';
import Layout from '@/components/layouts/HoldingTankLayout.vue';
import { useStore } from 'vuex';

export default {
  name: 'CarrierLimitExceeded',
  components: { Layout, ButtonMain },
  setup() {
    const store = useStore();
    const brokerLogo = ref(null);
    const brokerName = ref('');
    const companyType = computed(
      () => store.state.users.currentUser?.company?.company_type
    );

    const portalConfig = {
      carrier: {
        route: '/carrier/brokers',
        text: 'Go to Carrier Portal',
      },
      broker: {
        route: '/carrier/brokers',
        text: 'Go to Carrier Portal',
      },
      dispatcher: {
        route: '/dispatcher',
        text: 'Go to Dispatcher Portal',
      },
    };

    const fetchBrokerDetails = async () => {
      const clientId = localStorage.getItem('client_id');
      if (clientId) {
        const publicDetails = await store.dispatch(
          'brokers/getLogoByClientId',
          clientId
        );
        if (publicDetails.status === 200) {
          brokerLogo.value = publicDetails?.data?.url;
          brokerName.value = publicDetails?.data?.legal_name || '';
        }
      }
    };

    onMounted(fetchBrokerDetails);

    return {
      brokerLogo,
      brokerName,
      companyType,
      portalConfig,
    };
  },
};
</script>

<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-6 text-dark-blue md:mb-8;
}

.link-icon {
  position: relative;
  bottom: 1px;
}
</style>
